import { dataSave } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSave = /*#__PURE__*/createIcon(dataSave)
export default IconSave
